<script setup>
import { computed, useId } from "vue";
const props = defineProps({ modelValue: [String, Number, Boolean], label: String, type: { type: String, default: "text" }, options: { type: Array, default: () => [] }, required: Boolean, disabled: Boolean });
const emit = defineEmits(["update:modelValue"]);
const id = useId();
const value = computed({ get: () => props.modelValue, set: value => emit("update:modelValue", value) });
</script>
<template>
  <label class="field" :for="id">
    <span>{{ label }}</span>
    <select v-if="type === 'select'" :id="id" v-model="value" :required="required" :disabled="disabled">
      <option value="">—</option><option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</option>
    </select>
    <textarea v-else-if="type === 'textarea'" :id="id" v-model="value" :required="required" :disabled="disabled" rows="4" />
    <input v-else-if="type === 'checkbox'" :id="id" v-model="value" type="checkbox" :disabled="disabled" />
    <input v-else :id="id" v-model="value" :type="type" :required="required" :disabled="disabled" />
  </label>
</template>
